import { DimSymbolsCommand } from 'slotworks/commands/symbols/dim-symbols-command';
import { DisplaySymbolsCommand } from 'slotworks/commands/symbols/display-symbols-command';
import { PlaySymbolSoundCommand } from 'slotworks/commands/symbols/play-symbol-sound-command';
import { StaticSymbolsCommand } from 'slotworks/commands/symbols/static-symbols-command';
import { WinningSymbolsCommand } from 'slotworks/commands/symbols/winning-symbols-command';
import Components from 'slotworks/components/components';
import Layers from 'slotworks/graphics/layers/layers';
import AbstractMediator from 'slotworks/mediators/abstract-mediator';
import GameState from 'slotworks/model/game-state';
import Gamestate from 'slotworks/model/game-state';
import LineResult from 'slotworks/model/gameplay/records/results/line-result';
import SymbolWinResult from 'slotworks/model/gameplay/records/results/symbol-win-result';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import settingsModel from 'slotworks/model/settings/settings-model';
import SlotDefinition from 'slotworks/model/slot-definition';
import { SoundEvent } from 'slotworks/sound/sound-events';
import soundManager from 'slotworks/sound/sound-manager';
import { reject } from 'slotworks/utils/collection-utils';
import Contract from 'slotworks/utils/contract';
import Timer from 'slotworks/utils/timer';

export default class CycleWinsMediator extends AbstractMediator {
    public static DELAY: number = 0;
    private wins: SymbolWinResult[];
    private currentWin: number;
    private remainingSymbols: any;
    private winoverAnimations: any;
    private lowWinOnUk: boolean;

    public start(): Contract<void> {
        if (GameState.currentGameHasSymbolWinResults()) {
            const record = Gamestate.getCurrentGame().getCurrentRecord() as SpinRecord;
            record.timesCycled++;
            this.wins = record.getResultsOfType(SymbolWinResult) as SymbolWinResult[];
            this.currentWin = 0;
            this.lowWinOnUk = settingsModel.isUKJurisdiction() && !GameState.getCurrentGame().isWinAboveBet();
            Components.matrix.idleSymbols();
            return new Contract<void>(resolve => {
                for (let i = 0; i < Components.matrix.getAllSymbols().length; i++) {
                    Components.matrix.getAllSymbols()[i].setSymbolFade(true);
                }
                this.nextWin(resolve);
            });
        } else {
            return super.start();
        }
    }

    public end(): Contract<void> {
        for (let i = 0; i < this.winoverAnimations.length; i++) {
            Layers.SymbolAnimations.remove(this.winoverAnimations[i]);
            this.winoverAnimations[i].destroy();
        }
        return new Contract<void>(resolve => {
            this.wins = null;
            StaticSymbolsCommand().execute();
            Components.celebrateWin.hide();
            for (let i = 0; i < Components.matrix.getAllSymbols().length; i++) {
                Components.matrix.getAllSymbols()[i].setSymbolFade(true);
            }
            resolve(null);
        });
    }

    private nextWin(onComplete: Function) {
        const win = this.wins[this.currentWin];
        const symbol = SlotDefinition.getSymbolDefinition(win.symbolType);
        const symbolName = symbol ? symbol.name : '';

        if (win instanceof LineResult) {
            Components.celebrateWin.lineWin(win.creditsWon, win.line, symbolName, win.matches, 1).execute();
        } else if (win.creditsWon > 0) {
            Components.celebrateWin.lineWin(win.creditsWon, null, symbolName, win.matches).execute();
        }

        if (Layers.CelebrationContent.getText('value')) Layers.CelebrationContent.getText('value').position.y -= 50;
        this.showWin(win)
            .then(() => {
                Timer.setTimeout(() => {
                    if (!this.wins) {
                        return;
                    }
                    Components.matrix.idleSymbols();
                    this.currentWin++;
                    if (this.currentWin < this.wins.length) {
                        if (this.nextWin) {
                            this.nextWin(onComplete);
                        }
                    } else {
                        onComplete();
                    }
                }, 500);
            })
            .execute();
    }

    private showWin(win: SymbolWinResult): Contract<void> {
        const record = Gamestate.getCurrentGame().getCurrentRecord() as SpinRecord;
        const winningSymbols = [];
        const allWinningSymbols = [];
        this.winoverAnimations = [];

        for (const position of win.positions) {
            const symbol = Components.matrix.getSymbol(position.x, position.y);
            winningSymbols.push(symbol);
            allWinningSymbols.push(symbol);
        }

        const currentCycle = record.timesCycled;
        if (this.lowWinOnUk) {
            if (currentCycle == 1) soundManager.event(SoundEvent.symbol_win_below_threshold);
        } else {
            PlaySymbolSoundCommand(win.symbolType, win.matches.toString(), currentCycle.toString());
        }

        this.remainingSymbols = reject(Components.matrix.getAllSymbols(), allWinningSymbols);
        DimSymbolsCommand(this.remainingSymbols).execute();

        if (this.lowWinOnUk) return DisplaySymbolsCommand(winningSymbols);
        else return WinningSymbolsCommand(winningSymbols, record.beenPaid);
    }
}



// WEBPACK FOOTER //
// ./src/Mediator/loop-wins-mediator.ts